"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiUrl = exports.socket = void 0;
const socket_io_client_1 = require("socket.io-client");
const socketUrl = {
    prod: 'wss://prod.tria.so',
    staging: 'wss://staging.tria.so',
    dev: 'wss://dev.tria.so',
};
exports.socket = (0, socket_io_client_1.io)(socketUrl.prod); // socket url
exports.apiUrl = {
    mainnet: 'https://prod.tria.so',
    'mainnet-staging': 'https://staging.tria.so',
    testnet: 'https://staging.tria.so',
};
